import React from 'react';
import { postAnnouncementData, updateAnnoucementData } from '../../service/adminApi';
import { uploadBackend } from '../../utils/Upload';
import { getTimestampToDate } from '../../utils/dateConvetor';
import { OnlyNumber, OnlyNumberSpecialChar, OnlySpecialChar } from '../../utils/RegHandling';
window.Buffer = window.Buffer || require('buffer').Buffer;

function AnnouncementForm({ editData, handleData, hideContainer }) {
    let dataObj = {
        title: '',
        description: '',

        start_date: '',
        end_date: '',
    };

    let defaultAnnouncementError = {
        titleError: '',
        descriptionError: '',
        start_dateError: '',
        end_dateError: '',
        fileError: '',
    };

    const [announcementError, setAnnouncementError] = React.useState(defaultAnnouncementError);
    const [announcementData, setAnnouncementData] = React.useState(dataObj);
    const [selectedFileName, setSelectedFileName] = React.useState('');
    const [attachmentValidation, setattachmentValidation] = React.useState('');
    const textarearef = React.useRef(null);
    const fileInput = React.useRef(null);

    React.useEffect(() => {

        if (editData.title !== undefined && editData.title !== '') {
            setAnnouncementData(editData);
            let fileName = editData.attachment.split('/')[editData.attachment.split('/').length - 1];
            setSelectedFileName(fileName);
        }
    }, [editData]);

    const postAnnouncement = async (e) => {
        
        let dirName = `Announcement`;
        if (validateAnnouncementData() && attachmentValidation == '') {
            let file = fileInput.current.files[0];
            let data = announcementData;
            if (file !== undefined) {
                let newFileName = fileInput.current.files[0].name;
                let fileData = await uploadBackend(file, newFileName,dirName);
                data['attachment'] = fileData;
            }
            if (editData?.id === undefined) {
                const response = await postAnnouncementData(announcementData);
                if (response.data.statusCode == 200) {
                    setAnnouncementData(dataObj);
                    setSelectedFileName('');
                    handleData('update');
                    hideContainer();
                }
            } else {
                data['id'] = editData.id;
                const response = await updateAnnoucementData(announcementData);
                if (response.data.statusCode == 200) {
                    setAnnouncementData(dataObj);
                    setSelectedFileName('');
                    handleData('update');
                    hideContainer();
                }
            }
        }
    };

    const validateAnnouncementData = () => {
        let result = true;
        if (announcementData.title == undefined || announcementData.title == '' || announcementData.title == null) {
            setAnnouncementError((announcementError) => ({ ...announcementError, titleError: 'Announcement Title is required' }));
            result = false;
        } else if (OnlyNumberSpecialChar(announcementData.title)) {
            setAnnouncementError((announcementError) => ({ ...announcementError, titleError: 'Enter a valid Announcement Title' }));
            result = false;
        } else if (announcementData.title.length > 30) {
            setAnnouncementError((announcementError) => ({
                ...announcementError,
                titleError: 'The Announcement Title length should be less than 30',
            }));
            result = false;
        }
        if (announcementData.description == undefined || announcementData.description == '' || announcementData.description == null) {
            setAnnouncementError((announcementError) => ({ ...announcementError, descriptionError: 'Description is required' }));
            result = false;
        } else if (announcementData.description.length > 1000) {
            setAnnouncementError((announcementError) => ({
                ...announcementError,
                descriptionError: 'Description length should be less than 1000 character',
            }));
            result = false;
        }
        if (announcementData.start_date == undefined || announcementData.start_date == '' || announcementData.start_date == null) {
            setAnnouncementError((announcementError) => ({ ...announcementError, start_dateError: 'Start Date is required' }));
            result = false;
        }
        if (announcementData.end_date == undefined || announcementData.end_date == '' || announcementData.end_date == null) {
            setAnnouncementError((announcementError) => ({ ...announcementError, end_dateError: 'End Date is required' }));
            result = false;
        }
        if (selectedFileName == '' && attachmentValidation == '') {
            setAnnouncementError((announcementError) => ({ ...announcementError, fileError: 'Attachment is required' }));
            result = false;
        }
        return result;
    };

    const addFileName = (e) => {
      
        setSelectedFileName(e.target.files[0].name);
        setAnnouncementError((announcementError) => ({ ...announcementError, fileError: '' }));

        if (e.target.files[0].size >= 2000000) {
            setattachmentValidation('File size should be less than 2MB');
            return false;
        } else {
            setattachmentValidation('');
        }
        const typeArr = ['jpg', 'png', 'svg+xml', 'jpeg', 'svg'];
        let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
        if (type == false) {
            setattachmentValidation('The uploaded file should be in JPG, PNG, JPEG, SVG format');
            return false;
        } else {
            setattachmentValidation('');
        }
    };

    const resetData = () => {
        setSelectedFileName('');
        setAnnouncementData(dataObj);
        setAnnouncementError(defaultAnnouncementError);
        handleData('cancel');
        hideContainer();
    };

    return (
        <div>
            <div className="offcanvas-header">
                <h5 className=" tt-bold font-16 announcement-offcanvas-color">
                    {editData?.title === undefined || editData?.title === '' ? `Post` : `Update`} a announcement
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                        resetData();
                    }}
                />
            </div>
            <div className="offcanvas-body">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <label className="form-label tt-bold hive-form-label" htmlFor="Announcement-Title">
                            Announcement Title
                            <span className="hive-form-mandatory"> *</span>
                        </label>
                        <input
                            type="text"
                            className="form-control hive-form-control"
                            id="Announcement-Title"
                            placeholder="Title"
                            name="title"
                            value={announcementData.title}
                            onChange={(e) => {
                                setAnnouncementError((announcementError) => ({ ...announcementError, titleError: '' }));
                                setAnnouncementData((announcementData) => ({ ...announcementData, [e.target.name]: e.target.value }));
                            }}
                        />
                        <span className="text-danger font-12 tt-bold">{announcementError.titleError}</span>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label className="form-label hive-form-label" htmlFor="Add-description">
                            Add a description
                            <span className="required">*</span>
                        </label>
                        <textarea
                            className="form-control custom-comment-box hive-form-control"
                            id="Add-description"
                            ref={textarearef}
                            onBlur={() => {
                                textarearef.current.scrollTop = 0;
                            }}
                            rows={6}
                            placeholder="description"
                            name="description"
                            value={announcementData.description}
                            onChange={(e) => {
                                setAnnouncementError((announcementError) => ({ ...announcementError, descriptionError: '' }));
                                setAnnouncementData((announcementData) => ({ ...announcementData, [e.target.name]: e.target.value }));
                            }}
                        />
                        <span className="text-danger font-12 tt-bold">{announcementError.descriptionError}</span>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="custom-upload-btn-wrapper ">
                            <label className="form-label hive-form-label w-100">
                                Upload Image
                                <span className="hive-form-mandatory">*</span>
                            </label>
                            <label htmlFor={'announcement_attachment'} className="custom-file-upload-styles">
                                <img className="m-2" src="/Images/top-up.svg" alt="" />
                                Upload
                            </label>
                            <input
                                id="announcement_attachment"
                                ref={fileInput}
                                type="file"
                                onChange={(e) => {
                                    setAnnouncementError((announcementError) => ({ ...announcementError, fileError: '' }));
                                    addFileName(e);
                                }}
                                className="custom-file-upload-btn"
                                name="attachment"
                            />
                            <label className="font-12 w-100 regular-text">File size : less than 2mb</label>
                            <label className="font-12 w-100 regular-text font-blue">
                                {selectedFileName}{' '}
                                {selectedFileName !== '' && (
                                    <img
                                        src="/Images/icon-close.png"
                                        onClick={() => {
                                            setSelectedFileName('');
                                            setattachmentValidation('');
                                        }}
                                        alt="close"
                                    />
                                )}
                            </label>
                            <span className="text-danger font-12 tt-bold">{announcementError.fileError}</span>
                            {attachmentValidation ? <span className="text-danger font-12 tt-bold">{attachmentValidation}</span> : null}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label font-15 bold-text announcement-offcanvas-color ">Date Range</label>
                        <div className="row mb-4">
                            <div className="col-md-3">
                                <label className="form-label hive-form-label" style={{ color: '#6c719b' }} htmlFor="start-date">
                                    Start Date
                                    <span className="required"> *</span>
                                </label>
                                <input
                                    onChange={(e) => {
                                        setAnnouncementError((announcementError) => ({ ...announcementError, start_dateError: '' }));
                                        setAnnouncementData((announcementData) => ({
                                            ...announcementData,
                                            [e.target.name]: e.target.value,
                                        }));
                                    }}
                                    name="start_date"
                                    value={getTimestampToDate(announcementData.start_date, 2)}
                                    type="date"
                                    className="form-control hive-form-control"
                                    id="start-date"
                                />
                                <span className="text-danger font-12 tt-bold">{announcementError.start_dateError}</span>
                            </div>
                            <div className="col-md-1 align-self-end d-flex justify-content-center">
                                <img src="/Images/right-arrow.svg" alt="right-arrow" className="mb-3" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label hive-form-label" style={{ color: '#6c719b' }} htmlFor="end-date">
                                    End Date
                                    <span className="required"> *</span>
                                </label>
                                <input
                                    type="date"
                                    name="end_date"
                                    value={getTimestampToDate(announcementData.end_date, 2)}
                                    className="form-control hive-form-control"
                                    id="end-date"
                                    min={announcementData.start_date}
                                    onChange={(e) => {
                                        setAnnouncementError((announcementError) => ({ ...announcementError, end_dateError: '' }));
                                        setAnnouncementData((announcementData) => ({
                                            ...announcementData,
                                            [e.target.name]: e.target.value,
                                        }));
                                    }}
                                />
                                <span className="text-danger font-12 tt-bold">{announcementError.end_dateError}</span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mb-4 mt-5 p-0 ">
                        <button
                            onClick={() => {
                                resetData();
                            }}
                            className="btn hive-btn-secondary me-3"
                        // data-bs-dismiss="offcanvas"
                        // aria-label="Close"
                        >
                            Cancel
                        </button>
                        <button
                            className="btn me-4 hive-btn-primary"
                            onClick={() => {
                                postAnnouncement();
                            }}
                        >
                            {editData?.title == undefined || editData?.title == '' ? `Post` : `Update`}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AnnouncementForm;
